import React, {Component} from 'react';
// import $ from 'jquery';
import PageLoader from './loader';
import MainComponent from './MainComponent';
import {getAjax} from './../functions/functions.js';
import $ from "jquery";
import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './css/redis-instances-status.css';


class DeviceCacheNotifierRedisInstancesTableMenu extends Component {
    constructor(props) {
        super(props);

        this.state = {
            table_state: props.table_state
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            table_state: nextProps.table_state
        });
    }


    render() {
        let data = this.state.table_state.redis_data;
        let nr_of_conn = Object.keys(data).length;
        return (
            <div className="">
                Total number of Redis Instances: {nr_of_conn}
            </div>
        );
    }
}

class DeviceCacheNotifierRedisInstances extends MainComponent {
    constructor() {
        super();
        let thisComponent = this;

        this.state = {
            redis_data: this.noDataPreloader()
        };

        this.state = {
            'redis_load_data': setInterval(function () {
                thisComponent.loadData(global.mainDomainName + '?get_device_cache_notifier_redis_instances_status_alive&only_json', (component, data) => {
                    if (typeof data === 'string') {
                        return;
                    }

                    // if (!isJson(data)) {
                    if (data || typeof data === 'object') {
                        thisComponent.setState({
                            redis_data: data
                        });
                    }
                });
            }, 1000)
        };
    }

    //

    componentWillUnmount() {
        let thisComponent = this;
        let interval_key = thisComponent.get('redis_load_data');
        clearInterval(interval_key);
    }


    generateTableRows() {
        {
            // let data = JSON.parse(this.state.redis_data);
            // console.log("Generating table rows..");
            // console.log(data);
            // console.log(Object.values(data));


            return Object.entries(this.state.redis_data).map((value, i) => {
                // console.log(value);
                // console.log(value[0]);
                let k = value[0];
                let v = value[1];

                // console.log(value);

                let style_class;
                if (!v) {
                    style_class = "row-red";
                } else {
                    style_class = "row-green";
                }

                return (
                    <tr key={k} className={style_class}>
                        <td>{k}</td>
                        <td>{v.toString()}</td>
                    </tr>
                );
            });
        }
    }


    noDataPreloader() {
        return (<PageLoader/>);
    }

    get_nr_of_conn() {
        let data = JSON.parse(this.state.redis_data);
        // console.log(data);
        // console.log('nr of conn: ' + data.length);
        return Object.keys(data).length;
    }

    render() {
        if (this.state.redis_data == null) return this.noDataPreloader();
        // console.log('rendering...');

        return (
            <div>
                <DeviceCacheNotifierRedisInstancesTableMenu table_state={this.state}/>
                <table className="table">
                    <thead>
                    <tr>
                        <th scope="col">Redis Instance Name</th>
                        <th scope="col">Is Online</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.generateTableRows()}
                    </tbody>
                </table>
                <ToastContainer/>
            </div>
        );
    }
}

export default DeviceCacheNotifierRedisInstances;



// WEBPACK FOOTER //
// ./src/components/DeviceCacheNotifierRedisInstances.js